import React, { memo } from 'react';
import {
  StyledPlayerHeaderWrapper,
  StyledTitle,
  StyledChannelItemLogo,
  StyledMetadata,
} from './ControlsStyledComponents';

interface IPlayerHeaderProps {
  title: string;
  description: string;
  logo?: string;
  idle?: boolean;
}

const PlayerHeader: React.FC<IPlayerHeaderProps> = memo((props) => {
  const { title, description = '', logo, idle } = props;

  return (
    <StyledPlayerHeaderWrapper idle={idle}>
      {logo && <StyledChannelItemLogo logo={logo} />}
      <StyledTitle>{title}</StyledTitle>
      <StyledMetadata>
        <div>{description}</div>
      </StyledMetadata>
    </StyledPlayerHeaderWrapper>
  );
});

export default PlayerHeader;
